import { Building, Calendar, Clock } from 'lucide-react'
import { periodesDisponibles, semainesDisponibles } from '../../../../lib/groupes/sessions'
import type { SessionsGroupes } from './useSessionsGroupes'

const champ =
  'w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100'

/**
 * Centre, période, semaine. Changer de centre garde la période et la semaine
 * quand ce centre les propose aussi : passer d'Ixelles à Berchem pour la même
 * semaine ne doit pas tout remettre à zéro.
 */
export function FiltresSessions({ etat }: { etat: SessionsGroupes }) {
  const { sessions, filtre, setFiltre, centres, periodes, semaines } = etat

  const changerCentre = (centreId: string) => {
    const periode = periodesDisponibles(sessions, centreId).includes(filtre.periode) ? filtre.periode : ''
    const semaine = semainesDisponibles(sessions, centreId, periode).includes(filtre.semaine) ? filtre.semaine : ''
    setFiltre({ centreId, periode, semaine })
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <label className="block">
        <span className="block text-sm font-medium text-gray-700 mb-1">
          <Building className="h-4 w-4 inline mr-1" />
          Centre
        </span>
        <select value={filtre.centreId} onChange={(e) => changerCentre(e.target.value)} className={champ}>
          <option value="">Tous les centres</option>
          {centres.map((c) => (
            <option key={c.id} value={c.id}>
              {c.nom}
            </option>
          ))}
        </select>
      </label>

      <label className="block">
        <span className="block text-sm font-medium text-gray-700 mb-1">
          <Calendar className="h-4 w-4 inline mr-1" />
          Période
        </span>
        <select
          value={filtre.periode}
          onChange={(e) => setFiltre({ ...filtre, periode: e.target.value, semaine: '' })}
          className={champ}
        >
          <option value="">Toutes les périodes</option>
          {periodes.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
      </label>

      <label className="block">
        <span className="block text-sm font-medium text-gray-700 mb-1">
          <Clock className="h-4 w-4 inline mr-1" />
          Semaine
        </span>
        <select
          value={filtre.semaine}
          onChange={(e) => setFiltre({ ...filtre, semaine: e.target.value })}
          disabled={!filtre.periode}
          className={champ}
        >
          <option value="">Toutes les semaines</option>
          {semaines.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </label>
    </div>
  )
}
